import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-social',
    templateUrl: './social.component.html',
    standalone: false
})
export class SocialComponent {
  @Input() type;
}
